import _ from 'lodash'
import { isDividerItem } from '~/utils/orderDivider'
import { normalizeTableAlias } from '~/utils/tableAlias'
export const TYPES = {
    OPEN_SHOP: 100,
    ADD: 200,
    MOVE_TO: 310,
    MOVE_RECEIVED: 320,
    SPLIT: 330,

    SET_DISCOUNT_ITEMS: 340,
    SET_COMMENTS: 350,
    SET_PRICE: 360,
    SET_DELIVERY_INFO: 370,

    VOID: 500,
    VOID_TOPPING: 505,

    CLEAR_TABLE: 510,
    CLEAR_ALL: 520,
    PAY: 700,

    CLOSE_SHOP: 900
}

// Smallest quantity treated as "still on the table". Quantities are decimal —
// shops selling by weight enter 0.5 / 0.25 — and setQuantity rounds to 2 places,
// so any genuine remainder is >= 0.01. Anything below this is float noise from
// accumulated +=/-= (order 1e-16), never a real line.
const QTY_EPSILON = 1e-6

export class JobchainV1_1 {
    tableHolder: any = {};
    jobId: any = {};

    constructor(restoreHolder: any = {}) {
        this.tableHolder = restoreHolder || {};
        this.jobId = {};
    }

    public computeAllBlocks(JobLines: any[], { uuidItemToBillNumber = {} }: any = {}) {
        let tableHolder = this.tableHolder;
        let jobId = this.jobId;

        for (let index = 0; index < JobLines.length; index++) {
            let job: any = null
            try {

                job = JobLines[index];
                const thisTable = (job.alias ? this.normalizeAlias(job.alias, job) : null) || job.uuid   //current table

                if (!thisTable) {
                    continue;
                }

                const {
                    newAlias, //case move table
                    isMoveAll,
                    // RTDB does not store an empty object: a job written with
                    // json2 = {} comes back with no json2 at all (Sentry 7746015332).
                    json2: data2 = {},
                    isPayAll,
                    title,
                    mode,
                    deliveryInfo
                } = job

                let thisTableCartItems: any = null
                let uuidObj: any = null
                if (thisTable) {
                    uuidObj = tableHolder[thisTable] = tableHolder[thisTable] || this._generateTableObj(thisTable, job)
                    thisTableCartItems = uuidObj.items || [] //tableHolder[thisTable] = tableHolder[thisTable] || generateTableObj()
                    uuidObj.jobs.push(job)
                }

                let addHolderHelper = { addFrom: title || '_', job: job, data: {} as any }
                switch (job.type) {
                    case TYPES.ADD:
                        const data = JSON.parse(job.json)
                        addHolderHelper.data = data
                        //set start time
                        if (thisTableCartItems.length == 0) {
                            uuidObj.startTime = job.timestamp
                        }

                        if (jobId[data.uniqueid] == undefined) {

                            this.add(thisTableCartItems, data.orderitems || [], addHolderHelper)
                        }
                        jobId[data.uniqueid] = true;


                        //setGuests
                        if (data.isOpeningTable && data.guests) {
                            uuidObj.guests = data.guests;
                        }

                        break;

                    // done
                    case TYPES.PAY:
                        if (tableHolder[thisTable]) {
                            let newRemainingItems2 = this.voidItem(data2, thisTableCartItems)
                            tableHolder[thisTable].items = newRemainingItems2;

                            if (newRemainingItems2.length === 0) {
                                //clear table
                                delete tableHolder[thisTable];
                            }
                        }
                        break;


                    // done
                    case TYPES.VOID:
                        let newRemainingItems = this.voidItem(data2, thisTableCartItems)
                        tableHolder[thisTable].items = newRemainingItems;
                        if (newRemainingItems.length === 0) {
                            //clear table
                            delete tableHolder[thisTable];
                        }
                        //USED_CMD.VOID = true

                        break;

                    // Void ONE topping off a line without touching the line itself.
                    // data2 is nested: { [parentUniqueid]: { [String(toppingId)]: -qty } }.
                    // Only line.toppings[] is mutated — base item quantity and the
                    // line's presence are untouched (voiding a topping never empties
                    // a table), and calculateItems recomputes toppingsAmount /
                    // extendedPrice from the trimmed array on the next replay.
                    case TYPES.VOID_TOPPING:
                        tableHolder[thisTable].items = this.voidTopping(data2, thisTableCartItems)
                        break;
                    case TYPES.SPLIT:
                        let carts_after_splited = this.split_items(data2, thisTableCartItems, addHolderHelper)
                        tableHolder[thisTable].items = carts_after_splited;
                        break;

                    case TYPES.SET_COMMENTS:
                        let itemsCommentModifed = this.set_comments(data2, thisTableCartItems,)
                        tableHolder[thisTable].items = itemsCommentModifed;
                        break;

                    case TYPES.SET_DISCOUNT_ITEMS:
                        let itemsDiscountModifed = this.set_discount_items(data2, thisTableCartItems,)
                        tableHolder[thisTable].items = itemsDiscountModifed;
                        break;

                    case TYPES.SET_PRICE:
                        let itemsPriceModifed = this.set_price(data2, thisTableCartItems,)
                        tableHolder[thisTable].items = itemsPriceModifed;
                        break;
                    case TYPES.SET_DELIVERY_INFO:
                        tableHolder[thisTable].deliveryInfo = deliveryInfo;
                        break;

                    case TYPES.MOVE_TO:

                        const normalizedNewAlias = this.normalizeAlias(newAlias, job)
                        let newTableCartItems = tableHolder[normalizedNewAlias] = tableHolder[normalizedNewAlias] || this._generateTableObj(normalizedNewAlias, job)

                        if (isMoveAll) {
                            // Snapshot BEFORE the add: does the destination already
                            // have a party, or is it a fresh table this move opens?
                            const destHadItems = (newTableCartItems.items?.length || 0) > 0

                            this.add(newTableCartItems.items, thisTableCartItems, addHolderHelper)

                            // Carry the party's session metadata (guests / start
                            // time / delivery info) onto the destination before the
                            // source is dropped: a fresh destination inherits it,
                            // an existing party keeps its own and only gets keys it
                            // is missing. Mirrors the TableStates carry-over on the
                            // action side (pos.tableInstance.move).
                            this._carryOverTableMetadata(tableHolder[thisTable], newTableCartItems, destHadItems)

                            // Source is fully emptied by the move — delete it
                            // outright, the same way VOID / PAY drop a table once
                            // its last item is gone, instead of leaving an empty
                            // shell for cleanEmptyTables() to sweep.
                            delete tableHolder[thisTable]

                            //USED_CMD.MOVE_ALL = true
                        } else {
                            // get moves items
                            let _items_to_move = this.getItemsFromKey(data2, thisTableCartItems)

                            // add to new table
                            this.add(newTableCartItems.items, _items_to_move, addHolderHelper)

                            // remove from current table
                            tableHolder[thisTable].items = this.removeItemsFromCurrentTable(data2, thisTableCartItems)
                            //USED_CMD.MOVE_SOME = true

                        }
                        break;

                    case TYPES.CLEAR_TABLE:
                        tableHolder[thisTable].items = []

                        break;

                    case TYPES.CLEAR_ALL:
                        // becasue it incliudes delviery for this type
                        // ถ้า clear all tables -- ระบบจะวนคำสั่งลบที่แต่ละโต๊ะย่อยๆ อยู่แล้ว
                        // tableHolder = {}
                        break;

                    case TYPES.OPEN_SHOP:
                        if (index == 0) {
                            // prevent other re open shop
                            this.tableHolder = {}
                            tableHolder = this.tableHolder
                        }
                        break;

                    case TYPES.CLOSE_SHOP:

                        let sumItemLines = 0
                        for (var key in tableHolder) {

                            let itemsCart = tableHolder[key]
                            var count = itemsCart.items.length;
                            sumItemLines += count;

                        }


                        if (sumItemLines !== 0) {
                            console.log(`**** CLOSE SHOP NOT COMPLATE : line has  ${sumItemLines} lines `)
                        } else {
                            // tableHolder = {}

                        }

                        break;
                    default:
                        break;
                }

                uuidObj.lastUpdate = job.timestamp

            } catch (error) {

                // Support log — enough to find the bad job in RTDB and delete it.
                // RTDB key = jobId with "." → "_" (see pos.jobs.ts).
                const actionName = _.findKey(TYPES, (v) => v === job?.type) || 'UNKNOWN'
                const value = job?.json2 ?? job?.json ?? null
                console.error(`[jobchain] job ID : ${job?.jobId} (RTDB key: ${String(job?.jobId || '').replaceAll('.', '_')})`)
                console.error(`[jobchain] action : ${actionName} (${job?.type}) "${job?.title || ''}" table=${job?.alias || job?.uuid || ''} value=${typeof value === 'string' ? value : JSON.stringify(value)}`)
                console.error(job)
                throw error
            }

        }

        this.setBill(uuidItemToBillNumber)
        this.cleanEmptyTables()

        return this.tableHolder
    }

    // TOTAL on purpose — it assigns every line, defaulting to bill 1, instead of
    // only touching lines present in the map. On a full replay both forms give the
    // same answer (add() seeds every new line with bill = 1 before this runs), but
    // only this one is idempotent, and idempotence is required: the billing pass
    // re-runs setBill against an ALREADY-REPLAYED holder, so a guarded version
    // would leave a stale bill number on a line whose split assignment was just
    // cleared — that line could never return to bill 1 without a new job.
    public setBill(uuidItemToBillNumber: any) {
        const map = uuidItemToBillNumber || {}
        _.forEach(this.tableHolder, (table: any) => {
            _.forEach(table.items, (item: any) => {
                item.bill = map[item.uniqueid] || 1
            })
        })
    }


    public cleanEmptyTables() {
        _.forEach(this.tableHolder, (table: any) => {
            if (table.items.length == 0) {
                delete this.tableHolder[table.uuid]
            }
            table.__items = table.items
            delete table.jobs
            // delete table.items

        })
    }

    public logCart(table: string) {
        const blockchainHolder = this.tableHolder;
        console.log(' ')

        let tableInstance = blockchainHolder[table] || [];
        console.log(`Table : ${table} has ${tableInstance.items.length} lines`)
        let qty = 0
        tableInstance.items.forEach((line: any) => {
            // console.log(`${line.quantity} X ${line.name}`)

            console.log(`${line.quantity} X ${line.name}       \t\t    ${line.uniqueid}     \t\t    ${line.key}`)
            qty += line.quantity
        })
        console.log('qty ' + qty)

        console.log(' ')

        console.log(tableInstance.jobs)

        console.log('legth', tableInstance.jobs.length)
    }

    public logCartAll() {
        const blockchainHolder = this.tableHolder;
        console.log(' ')

        for (const table in blockchainHolder) {
            let tableInstance = blockchainHolder[table] || [];
            if (tableInstance.items.length == 0) {
                continue
            }

            console.log(`Table : ${table} has ${tableInstance.items.length} lines`)
            let qty = 0
            tableInstance.items.forEach((line: any) => {
                console.log(`${line.quantity} X ${line.name}`)
                // console.log(`${line.quantity} X ${line.name}       \t\t    ${line.uniqueid}     \t\t    ${line.key}`)
                qty += line.quantity
            })
            console.log('qty ' + qty)

            console.log(' ')
        }
    }

    public static analytic(jobs: any[]) {
        function sumJson2(object: any) {
            let sum = 0
            for (const key in object) {
                if (Object.hasOwnProperty.call(object, key)) {
                    const val = object[key];
                    sum += val
                }
            }
            return sum
        }

        function sumItemsQty(items: any[]) {
            let qty = 0
            items.forEach((line) => {
                qty += line.quantity
            })
            return qty
        }
        let res: any = {
            add: 0,
            void: 0,
            paid: 0
        };

        for (let index = 0; index < jobs.length; index++) {
            const job = jobs[index];

            switch (job.type) {
                case TYPES.ADD:
                    let order = JSON.parse(job.json)
                    res.add += sumItemsQty(order.orderitems)
                    break;
                case TYPES.VOID:
                    res.void += sumJson2(job.json2)
                    break;
                case TYPES.PAY:
                    res.paid += sumJson2(job.json2)

                    break;
                default:
                    break;
            }
        }
        res.sum = res.add + res.void
        return res
    }

    public static genItemLineKey(item: any) {
        //if has default discount
        let discountRequest = item.discountrequest || {
            mode: 0,
            value: 0
        }


        if (item.oneLine || item.toppings && item.toppings.length >= 1 || item.comments || item.Comments || item.isTogo || item.isopenmenu || item.isOpenMenu) {
            return item.uniqueid    //การใช้ unique id คือ จะเป็นแถวเดียวแน่ๆ
        }

        // return `${item.subitemid}:${item.price}`
        return `${item.subitemid}:${item.price}:${discountRequest.mode}:${discountRequest.value}`
    }

    // Implementation lives in ~/utils/tableAlias so other writers (e.g. the
    // mobile-v2 history plugin) can key their nodes with the SAME key space the
    // jobchain uses for `tables`. Behaviour is unchanged.
    private normalizeAlias(rawAlias: any, job: any): string {
        return normalizeTableAlias(rawAlias, job)
    }

    private _generateTableObj(uuid: string, job: any) {
        return {
            items: [],
            uuid,
            name: this.normalizeAlias(job.newAlias || job.alias, job) || job.uuid || '',
            nickName: job.nickName || '',
            mode: job.mode || 1,
            jobs: [],
            employeeName: job.employee?.name || '',
            startDateTime: job.pcTimestamp || job.timestamp,
            lastUpdate: job.pcTimestamp || job.timestamp,
            deliveryInfo: job.deliveryInfo || null,
            guests: job.guests || 2
        }
    }

    // Move-all carry-over: relocate the party's SESSION metadata from the source
    // table onto the destination. Deliberately excludes the destination's own
    // identity (uuid / name / nickName / mode) and its item/job lists — those
    // belong to the destination. Rule matches the TableStates carry-over:
    //   - destination is fresh (no party) → inherit the source's values.
    //   - destination already has a party → keep ITS values, only fill the keys
    //     it is missing (never overwrite — the destination is authoritative).
    private _carryOverTableMetadata(source: any, dest: any, destHadItems: boolean) {
        if (!source || !dest) return
        const META_KEYS = ['guests', 'startTime', 'startDateTime', 'deliveryInfo']
        META_KEYS.forEach((key) => {
            const srcVal = source[key]
            if (srcVal === undefined || srcVal === null) return
            const destHasValue = dest[key] !== undefined && dest[key] !== null
            if (!destHadItems || !destHasValue) {
                dest[key] = srcVal
            }
        })
    }

    private add(currentItems: any[], newOrderItems: any[], { addFrom, data }: any) {

        newOrderItems.forEach((newItem: any, i: number) => {

            // Divider ("ตีเส้น") lines are print-only: the kitchen slip renders them
            // from the raw per-round job payload, but they must NEVER persist on the
            // accumulated table. Legacy did the same (table.terminal.js: subitemid==1
            // → continue). Dropping them here keeps display, totals, item counts,
            // split and void clean automatically, and avoids every divider merging
            // into one row (they all share genItemLineKey `1:0:0:0`).
            if (isDividerItem(newItem)) {
                return
            }

            if (!newItem.uniqueid) {
                newItem.uniqueid = data.uniqueid + ":" + i
                newItem.oneLine = true
            }

            if (newItem.isopenmenu || newItem.isOpenMenu) {
                newItem.oneLine = true
                newItem.isOpenMenu = true
            }

            let key = JobchainV1_1.genItemLineKey(newItem);
            newItem.key = key;

            // set discount default — but PRESERVE a per-item discount that was
            // already applied via SET_DISCOUNT_ITEMS. That job writes only to
            // `discountRequest` (capital R), never to the raw `discountrequest`
            // (lowercase). A MOVE re-runs this same add() over the existing cart
            // items, so rebuilding from the lowercase field would reset the 50%
            // back to 0 and the discount would vanish on move. On a genuine first
            // ADD the capital field doesn't exist yet → falls back to the default.
            newItem.discountRequest = newItem.discountRequest || {
                mode: (newItem.discountrequest && newItem.discountrequest.mode) || 0,
                value: (newItem.discountrequest && newItem.discountrequest.value) || 0,
            }




            if (addFrom) {
                newItem.addFrom = addFrom
            }
            let foundInCart = this.findItemInCart(currentItems, newItem)
            if (foundInCart) {
                foundInCart.quantity += newItem.quantity;

                foundInCart.refs[newItem.uniqueid] = true

            } else {
                foundInCart = newItem
                foundInCart.refs = {
                    [newItem.uniqueid]: true
                }
                currentItems.push(newItem);
            }


            newItem.bill = 1






        })
    }

    private findItemInCart(currentItems: any[], newItem: any) {

        return _.find(currentItems, (thisline) => {

            return thisline.key === newItem.key
            // && thisline.discountRequest.mode == newItem.discountRequest.mode
            // && thisline.discountRequest.value == newItem.discountRequest.value

        })
    }

    private split_items(idHolder: any, cart_items: any[], { job, setBillHolder = {} }: any) {
        let res: any[] = []
        cart_items.forEach((line) => {

            if (idHolder[line.uniqueid]) {
                // found
                let newQty = Math.abs(idHolder[line.uniqueid])
                line.quantity = line.quantity - newQty

                let item_clone = JSON.parse(JSON.stringify(line))
                item_clone.quantity = newQty
                item_clone.uniqueid = line.uniqueid + ':' + job.timestamp.replace('.', '_')
                item_clone.oneLine = true
                item_clone.refs = {
                    [item_clone.uniqueid]: true
                }
                item_clone.key = JobchainV1_1.genItemLineKey(item_clone)
                item_clone.bill = 1

                res.push(line)
                res.push(item_clone)



            } else {
                //not relate
                res.push(line)
            }
        })
        return res
    }

    private set_comments(idHolder: any, cart_items: any[]) {

        cart_items.forEach((line) => {

            if (idHolder?.[line.uniqueid] !== undefined) {
                // found
                line.comments = idHolder[line.uniqueid]
                line.oneLine = true
                line.key = JobchainV1_1.genItemLineKey(line)
            }
        })

        return cart_items
    }

    private set_price(idHolder: any, cart_items: any[]) {
        cart_items.forEach((line) => {

            if (idHolder[line.uniqueid] !== undefined) {
                // found
                line.price = idHolder[line.uniqueid] || 0
                line.oneLine = true

                line.key = JobchainV1_1.genItemLineKey(line)
            }
        })
        return cart_items

    }

    private set_discount_items(idHolder: any, cart_items: any[]) {

        cart_items.forEach((line) => {

            if (idHolder[line.uniqueid] !== undefined) {
                // found
                // json2 = [mode, value]. For mode 1 `value` is PER PIECE; the
                // ×quantity is applied downstream (TableHelper.calculateItems).
                line.discountRequest.mode = idHolder[line.uniqueid][0]
                line.discountRequest.value = idHolder[line.uniqueid][1]
                line.oneLine = true
                line.key = JobchainV1_1.genItemLineKey(line)
            }
        })
        return cart_items

    }

    private removeItemsFromCurrentTable(uniqueidHolder: any, thisTableCartItems: any[]) {

        let res: any[] = []
        thisTableCartItems.forEach((line) => {
            if (uniqueidHolder[line.uniqueid] == undefined) {
                // not found
                res.push(line)
            }
        })

        return res
    }

    private getItemsFromKey(keysHolder: any, itemsInCart: any[]) {

        let res: any[] = []
        itemsInCart.forEach((line, index) => {
            // find item by key 
            if (keysHolder[line.uniqueid]) {
                res.push(line)
            }


        })

        return res
    }


    private voidItem(keyHolders: any = {}, carts: any[] = []) {
        let resRemainigItems: any[] = []
        if (carts === null) {
            return resRemainigItems
        }
        carts.forEach((line) => {
            let qtyToVoid = keyHolders[line.uniqueid] // negative qty
            // Consume ANY numeric entry, not just `< 0`. A qty-0 line produces
            // `json2[uniqueid] === 0` (PAY/VOID both build it as `quantity * -1`),
            // and the old `< 0` gate let that fall through to the else-branch,
            // which pushed the line straight back onto the table — no void and no
            // payment could ever clear it, so the table could never close. The
            // typeof check keeps MOVE-style holders (`true`) out of the arithmetic.
            if (typeof qtyToVoid === 'number') {
                line.quantity -= Math.abs(qtyToVoid)
                // Keep the line while a real remainder is left. This used to test
                // `>= 1`, which silently DELETED any fractional remainder: shops
                // selling by weight (0.5 kg etc — see setQuantity, which rounds to
                // 2 decimals on purpose) lost the leftover off the bill entirely,
                // e.g. void 0.5 of 1 kg dropped the whole line instead of leaving
                // 0.5. Compared against an epsilon, not 0, because quantities are
                // accumulated with `+=` in add(): voiding 0.9 three times off 2.7
                // leaves 2.2e-16, and a bare `> 0` would keep that float residue
                // as a phantom line — unkillable for exactly the same reason a
                // qty-0 line was (json2 rounds it to 0, so no later void matches).
                line.quantity > QTY_EPSILON && resRemainigItems.push(line)
            } else {
                resRemainigItems.push(line)
            }
        })

        return resRemainigItems

    }

    // Topping-level void — mirrors voidItem, but reduces a topping's quantity
    // inside line.toppings[] instead of the line quantity. The parent line is
    // ALWAYS kept (a base item stays sold even when all its toppings are voided).
    //
    // toppingHolder is nested: { [parentUniqueid]: { [String(toppingId)]: -qty } }.
    // A line with no entry (or a non-object entry) passes through untouched.
    //
    // TIMELINE-SWAP SAFETY: cashier terminals have skewed clocks, so a VOID_TOPPING
    // can carry an EARLIER timestamp than the ADD that creates its parent line and
    // sort AHEAD of it in the replay. When that happens the parent line simply is
    // not in `carts` yet — the loop never touches it and the void is a silent
    // no-op this pass (exactly the tolerance voidItem has for an early whole-line
    // void). This function must NEVER throw on missing/malformed input: a single
    // throw aborts computeAllBlocks (it re-throws) and breaks the whole chain.
    private voidTopping(toppingHolder: any = {}, carts: any[] = []) {
        // carts missing/not an array → nothing on the table to void yet.
        if (!Array.isArray(carts)) {
            return Array.isArray(carts) ? carts : []
        }
        // No void map at all (null / undefined / not an object) → leave the cart
        // untouched. Default params only cover `undefined`, so a literal `null`
        // json2 would otherwise deref-throw below.
        if (!toppingHolder || typeof toppingHolder !== 'object') {
            return carts
        }

        carts.forEach((line) => {
            if (!line) {
                return
            }
            const toppingVoidMap = toppingHolder[line.uniqueid]
            // No void targets this line (or the parent isn't on the table yet, or a
            // non-object holder slipped in) — leave it alone.
            if (!toppingVoidMap || typeof toppingVoidMap !== 'object') {
                return
            }
            if (!Array.isArray(line.toppings)) {
                return
            }

            line.toppings = line.toppings.reduce((remaining: any[], topping: any) => {
                if (!topping || typeof topping !== 'object') {
                    // Preserve anything malformed rather than dropping it silently.
                    if (topping !== undefined && topping !== null) {
                        remaining.push(topping)
                    }
                    return remaining
                }
                // toppingId is a number in the raw ADD json but stringified on the
                // display side; the void map keys are strings (object keys always
                // are). Coerce so `map[7063]` and `map["7063"]` both match.
                const qtyToVoid = toppingVoidMap[String(topping.toppingId)]
                if (typeof qtyToVoid === 'number') {
                    // Same fractional-remainder / epsilon reasoning as voidItem:
                    // keep a genuine leftover (>= 0.01), drop float noise and 0.
                    topping.quantity = (topping.quantity || 0) - Math.abs(qtyToVoid)
                    if (topping.quantity > QTY_EPSILON) {
                        remaining.push(topping)
                    }
                } else {
                    remaining.push(topping)
                }
                return remaining
            }, [])
        })

        return carts
    }
}
